<template>
  <div v-if="$isMobile()"> <!--smartphone-->
    <div :class="mode ? 'dark-theme' : 'light-theme'">
      <h1 class="mt-4 mb-0 text-center">
        <strong data-bs-toggle="modal" data-bs-target="#info">Routine</strong>
      </h1>

      <div class="d-flex justify-content-center pb-4">
        <button
          type="button"
          class="btn btn-dark btn-sm text-center"
          data-bs-toggle="modal"
          data-bs-target="#modaleGruppo"
        >
          <p class="fa fa-plus m-0 p-0"></p>
        </button>
        <button
          type="button"
          class="btn btn-dark btn-sm text-center ms-2 me-2"
          data-bs-toggle="modal"
          data-bs-target="#modaleElimina"
        >
          <p class="fa fa-trash-o m-0 p-0"></p>
        </button>

        <div class="vertical-line" style="height: 31px"></div>

        <button
          type="button"
          class="btn btn-dark btn-sm text-center ms-2"
          v-on:click="cambiaMod()"
        >
          <p class="fa fa-moon-o m-0 p-0" v-if="mode == false"></p>
          <p class="fa fa-sun-o m-0 p-0" v-if="mode == true"></p>
        </button>
        <button
          type="button"
          class="btn btn-dark btn-sm text-center ms-2 me-2"
          v-on:click="modoDiVisualizzazione()"
        >
          <p class="fa fa-eye m-0 p-0" v-if="soloOggi"></p>
          <p class="fa fa-low-vision m-0 p-0" v-if="!soloOggi"></p>
        </button>

        <div class="vertical-line" style="height: 31px"></div>

        <button
          type="button"
          class="btn btn-dark btn-sm text-center ms-2 me-2"
          data-bs-toggle="modal"
          data-bs-target="#attività"
        >
          <p class="fa fa-database m-0 p-0"></p>
        </button>
      </div>

      <div
        class="row align-items-center shadow rounded mx-3 mb-3"
        v-if="giornoDaVisualizzare == 0 || giornoDaVisualizzare == 1"
      >
        <h5 class="text-center m-0 p-0 my-2">Lunedì</h5>

        <div v-for="(y, i) in impegni" v-bind:key="i">
          <div class="card mb-2" v-if="y.lista == 1" v-on:dblclick="elimina(i)">
            <div class="card-body">
              <p
                class="h6 card-subtitle text-muted m-0"
                v-if="giornoSettimana <= 1"
              >
                {{ y.orario }}
              </p>
              <p class="h5 card-title m-0" v-if="giornoSettimana <= 1">
                {{ y.titolo }}
              </p>

              <p
                class="h6 card-subtitle text-muted m-0"
                v-if="giornoSettimana > 1"
              >
                <del>{{ y.orario }}</del>
              </p>
              <p class="h5 card-title m-0" v-if="giornoSettimana > 1">
                <del>{{ y.titolo }}</del>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="row align-items-center shadow rounded mx-3 mb-3"
        v-if="giornoDaVisualizzare == 0 || giornoDaVisualizzare == 2"
      >
        <h5 class="text-center m-0 p-0 my-2">Martedì</h5>

        <div v-for="(y, i) in impegni" v-bind:key="i">
          <div class="card mb-2" v-if="y.lista == 2" v-on:dblclick="elimina(i)">
            <div class="card-body">
              <p
                class="h6 card-subtitle text-muted m-0"
                v-if="giornoSettimana <= 2"
              >
                {{ y.orario }}
              </p>
              <p class="h5 card-title m-0" v-if="giornoSettimana <= 2">
                {{ y.titolo }}
              </p>

              <p
                class="h6 card-subtitle text-muted m-0"
                v-if="giornoSettimana > 2"
              >
                <del>{{ y.orario }}</del>
              </p>
              <p class="h5 card-title m-0" v-if="giornoSettimana > 2">
                <del>{{ y.titolo }}</del>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="row align-items-center shadow rounded mx-3 mb-3"
        v-if="giornoDaVisualizzare == 0 || giornoDaVisualizzare == 3"
      >
        <h5 class="text-center m-0 p-0 my-2">Mercoledì</h5>

        <div v-for="(y, i) in impegni" v-bind:key="i">
          <div class="card mb-2" v-if="y.lista == 3" v-on:dblclick="elimina(i)">
            <div class="card-body">
              <p
                class="h6 card-subtitle text-muted m-0"
                v-if="giornoSettimana <= 3"
              >
                {{ y.orario }}
              </p>
              <p class="h5 card-title m-0" v-if="giornoSettimana <= 3">
                {{ y.titolo }}
              </p>

              <p
                class="h6 card-subtitle text-muted m-0"
                v-if="giornoSettimana > 3"
              >
                <del>{{ y.orario }}</del>
              </p>
              <p class="h5 card-title m-0" v-if="giornoSettimana > 3">
                <del>{{ y.titolo }}</del>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="row align-items-center shadow rounded mx-3 mb-3"
        v-if="giornoDaVisualizzare == 0 || giornoDaVisualizzare == 4"
      >
        <h5 class="text-center m-0 p-0 my-2">Giovedì</h5>

        <div v-for="(y, i) in impegni" v-bind:key="i">
          <div class="card mb-2" v-if="y.lista == 4" v-on:dblclick="elimina(i)">
            <div class="card-body">
              <p
                class="h6 card-subtitle text-muted m-0"
                v-if="giornoSettimana <= 4"
              >
                {{ y.orario }}
              </p>
              <p class="h5 card-title m-0" v-if="giornoSettimana <= 4">
                {{ y.titolo }}
              </p>

              <p
                class="h6 card-subtitle text-muted m-0"
                v-if="giornoSettimana > 4"
              >
                <del>{{ y.orario }}</del>
              </p>
              <p class="h5 card-title m-0" v-if="giornoSettimana > 4">
                <del>{{ y.titolo }}</del>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="row align-items-center shadow rounded mx-3 mb-3"
        v-if="giornoDaVisualizzare == 0 || giornoDaVisualizzare == 5"
      >
        <h5 class="text-center m-0 p-0 my-2">Venerdì</h5>

        <div v-for="(y, i) in impegni" v-bind:key="i">
          <div class="card mb-2" v-if="y.lista == 5" v-on:dblclick="elimina(i)">
            <div class="card-body">
              <p
                class="h6 card-subtitle text-muted m-0"
                v-if="giornoSettimana <= 5"
              >
                {{ y.orario }}
              </p>
              <p class="h5 card-title m-0" v-if="giornoSettimana <= 5">
                {{ y.titolo }}
              </p>

              <p
                class="h6 card-subtitle text-muted m-0"
                v-if="giornoSettimana > 5"
              >
                <del>{{ y.orario }}</del>
              </p>
              <p class="h5 card-title m-0" v-if="giornoSettimana > 5">
                <del>{{ y.titolo }}</del>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="row align-items-center shadow rounded mx-3 mb-3"
        v-if="giornoDaVisualizzare == 0 || giornoDaVisualizzare == 6"
      >
        <h5 class="text-center m-0 p-0 my-2">Sabato</h5>

        <div v-for="(y, i) in impegni" v-bind:key="i">
          <div class="card mb-2" v-if="y.lista == 6" v-on:dblclick="elimina(i)">
            <div class="card-body">
              <p
                class="h6 card-subtitle text-muted m-0"
                v-if="giornoSettimana <= 6"
              >
                {{ y.orario }}
              </p>
              <p class="h5 card-title m-0" v-if="giornoSettimana <= 6">
                {{ y.titolo }}
              </p>

              <p
                class="h6 card-subtitle text-muted m-0"
                v-if="giornoSettimana > 6"
              >
                <del>{{ y.orario }}</del>
              </p>
              <p class="h5 card-title m-0" v-if="giornoSettimana > 6">
                <del>{{ y.titolo }}</del>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="row align-items-center shadow rounded mx-3 mb-3"
        v-if="giornoDaVisualizzare == 0 || giornoDaVisualizzare == 7"
      >
        <h5 class="text-center m-0 p-0 my-2">Domenica</h5>

        <div v-for="(y, i) in impegni" v-bind:key="i">
          <div class="card mb-2" v-if="y.lista == 7" v-on:dblclick="elimina(i)">
            <div class="card-body">
              <p
                class="h6 card-subtitle text-muted m-0"
                v-if="giornoSettimana <= 7"
              >
                {{ y.orario }}
              </p>
              <p class="h5 card-title m-0" v-if="giornoSettimana <= 7">
                {{ y.titolo }}
              </p>

              <p
                class="h6 card-subtitle text-muted m-0"
                v-if="giornoSettimana > 7"
              >
                <del>{{ y.orario }}</del>
              </p>
              <p class="h5 card-title m-0" v-if="giornoSettimana > 7">
                <del>{{ y.titolo }}</del>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else> <!--pc o tablet-->
    <div :class="mode ? 'dark-theme' : 'light-theme'">
      <h1 class="mt-4 mb-0 text-center">
        <strong data-bs-toggle="modal" data-bs-target="#info">Routine</strong>
      </h1>

      <div class="d-flex justify-content-center pb-4">
        <button
          type="button"
          class="btn btn-dark btn-sm text-center ms-2"
          v-on:click="cambiaMod()"
        >
          <p class="fa fa-moon-o m-0 p-0" v-if="mode == false"></p>
          <p class="fa fa-sun-o m-0 p-0" v-if="mode == true"></p>
        </button>
      </div>

      <div
        class="row align-items-center shadow rounded mx-3 mb-3"
        v-if="giornoDaVisualizzare == 0 || giornoDaVisualizzare == 1"
      >
        <div class="alert alert-danger m-0 text-center" role="alert" :class="mode ? 'dark-theme' : 'light-theme'">
          L'applicazione non è disponibile per Desktop o Tablet, a breve lo sarà!
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade text-brown"
    id="info"
    :class="mode ? 'dark-theme' : 'light-theme'"
  >
    <informazioni></informazioni>
  </div>

  <div
    class="modal fade text-brown"
    id="modaleElimina"
    :class="mode ? 'dark-theme' : 'light-theme'"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title"><strong>Elimina impegni</strong></h4>
        </div>

        <div class="modal-body p-3">Vuoi eliminare tutti gli impegni?</div>

        <div class="modal-footer p-1 d-flex justify-content-center">
          <button
            type="button"
            class="btn btn-danger btn-sm"
            v-on:click="eliminaTutto()"
            data-bs-toggle="modal"
            data-bs-target="#modaleElimina"
          >
            <p class="fa fa-check-circle m-0 p-0"></p>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade text-brown"
    id="modaleGruppo"
    :class="mode ? 'dark-theme' : 'light-theme'"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title"><strong>Aggiungi un impegno</strong></h4>
        </div>

        <div class="modal-body p-1">
          <input
            type="text"
            class="form-control mb-1"
            placeholder="Titolo"
            v-model="titolo"
          />

          <div class="row g-2">
            <div class="col-md">
              <div class="form-floating">
                <select
                  class="form-select"
                  id="floatingSelectGrid"
                  aria-label="Floating label select example"
                  v-model="giorno"
                >
                  <option value="1">Lunedì</option>
                  <option value="2">Martedì</option>
                  <option value="3">Mercoledì</option>
                  <option value="4">Giovedì</option>
                  <option value="5">Venerdì</option>
                  <option value="6">Sabato</option>
                  <option value="7">Domenica</option>
                </select>
                <label for="floatingSelectGrid">Giorno:</label>
              </div>
            </div>

            <div class="col-md">
              <div class="form-floating">
                <select
                  class="form-select"
                  id="floatingSelectGrid"
                  aria-label="Floating label select example"
                  v-model="ora"
                >
                  <option value="00">00</option>
                  <option value="01">01</option>
                  <option value="02">02</option>
                  <option value="03">03</option>
                  <option value="04">04</option>
                  <option value="05">05</option>
                  <option value="06">06</option>
                  <option value="07">07</option>
                  <option value="08">08</option>
                  <option value="09">09</option>
                  <option value="10">10</option>
                  <option value="12">12</option>
                  <option value="13">13</option>
                  <option value="14">14</option>
                  <option value="15">15</option>
                  <option value="16">16</option>
                  <option value="17">17</option>
                  <option value="18">18</option>
                  <option value="19">19</option>
                  <option value="21">21</option>
                  <option value="22">22</option>
                  <option value="23">23</option>
                </select>
                <label for="floatingSelectGrid">Ora:</label>
              </div>
            </div>

            <div class="col-md">
              <div class="form-floating">
                <select
                  class="form-select"
                  id="floatingSelectGrid"
                  aria-label="Floating label select example"
                  v-model="minuto"
                >
                  <option value="00">00</option>
                  <option value="05">05</option>
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="20">20</option>
                  <option value="25">25</option>
                  <option value="30">30</option>
                  <option value="35">35</option>
                  <option value="40">40</option>
                  <option value="45">45</option>
                  <option value="50">50</option>
                  <option value="55">55</option>
                </select>
                <label for="floatingSelectGrid">Minuto:</label>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer p-1 d-flex justify-content-center">
          <button
            type="button"
            class="btn btn-dark"
            v-on:click="aggiungi(titolo, giorno, ora, minuto)"
          >
            Aggiungi
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade text-brown"
    id="attività"
    :class="mode ? 'dark-theme' : 'light-theme'"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title"><strong>Statistiche</strong></h4>
        </div>

        <grafico></grafico>

        <div class="modal-footer d-flex justify-content-center"></div>
      </div>
    </div>
  </div>
</template>

<script>
import informazioni from "./components/informazioni.vue"
import grafico from "./components/grafico.vue"

export default {
  name: "App",
  components: {
    informazioni,
    grafico
  },
  data() {
    return {
      impegni: [],
      // prompt: undefined,
      date: null,
      mode: false, // true black, false light
      giornoSettimana: new Date().getDay(),
      giornoDaVisualizzare: 0,
      soloOggi: false,
      grafico: null,
      xValues: [
        "Lunedì",
        "Martedì",
        "Mercoledì",
        "Giovedì",
        "Venerdì",
        "Sabato",
        "Domenica",
      ],
      yValues: [0, 0, 0, 0, 0, 0, 0],
    };
  },
  created() {
    console.log(this.$isMobile());
  },
  mounted() {
    if (this.giornoSettimana == 0) {
      this.giornoSettimana = 7;
    }

    if (this.giornoDaVisualizzare != 0) {
      this.giornoDaVisualizzare = this.giornoSettimana;
    }

    if (localStorage.getItem("impegni") != null) {
      this.impegni = JSON.parse(localStorage.getItem("impegni"));
      this.riordina();
    }

    if (localStorage.getItem("mode") == null) {
      localStorage.setItem("mode", JSON.stringify(this.mode));
    } else {
      this.mode = JSON.parse(localStorage.getItem("mode"));
    }

    if (this.mode == true) {
      document.body.className = "allblack";
    } else {
      document.body.className = "alllight";
    }

    if (localStorage.getItem("giorno") == null) {
      localStorage.setItem("giorno", JSON.stringify(0));
    } else {
      this.giornoDaVisualizzare = JSON.parse(localStorage.getItem("giorno"));
    }

    if (localStorage.getItem("soloOggi") == null) {
      localStorage.setItem("soloOggi", JSON.stringify(this.soloOggi));
    } else {
      this.soloOggi = JSON.parse(localStorage.getItem("soloOggi"));
    }

    for (let i = 0; i < this.impegni.length; i++) {
      this.yValues[this.impegni[i].lista - 1]++;
    }
  },
  methods: {
    conta() {
      this.yValues = [0, 0, 0, 0, 0, 0, 0];

      for (let i = 0; i < this.impegni.length; i++) {
        this.yValues[this.impegni[i].lista - 1]++;
      }

      this.grafico.data.datasets[0].data = this.yValues;
      this.grafico.update();
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    modoDiVisualizzazione() {
      this.soloOggi = !this.soloOggi;

      if (this.soloOggi == true) {
        this.giornoDaVisualizzare = this.giornoSettimana;
      } else {
        this.giornoDaVisualizzare = 0;
      }

      localStorage.setItem("giorno", JSON.stringify(this.giornoDaVisualizzare));
      localStorage.setItem("soloOggi", JSON.stringify(this.soloOggi));
    },
    cambiaMod() {
      this.mode = !this.mode;
      localStorage.setItem("mode", JSON.stringify(this.mode));

      if (this.mode == true) {
        document.body.className = "allblack";
      } else {
        document.body.className = "alllight";
      }
    },
    riordina() {
      this.impegni.sort((a, b) => {
        let fa = a.orario.toLowerCase(),
          fb = b.orario.toLowerCase();

        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }

        return 0;
      });
    },
    aggiungi(titolo, giorno, ora, minuto) {
      if (
        titolo == null ||
        giorno == undefined ||
        ora == undefined ||
        minuto == undefined
      )
        return;

      this.impegni.push({
        lista: giorno,
        titolo: titolo,
        orario: ora + ":" + minuto,
      });

      this.riordina();
      localStorage.setItem("impegni", JSON.stringify(this.impegni));

      this.conta();
    },
    elimina(pos) {
      this.impegni.splice(pos, 1);
      this.riordina();
      localStorage.setItem("impegni", JSON.stringify(this.impegni));

      this.conta();
    },
    eliminaTutto() {
      this.impegni = [];
      this.riordina();
      localStorage.setItem("impegni", JSON.stringify(this.impegni));

      this.conta();
    },
  },
};
</script>

<style>
body.allblack {
  background: black;
}

body.alllight {
  background: white;
}

.dark-theme {
  filter: invert(100%);
}

.light-theme {
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

div.vertical-line {
  width: 1px;
  background-color: black;
  height: 100%;
  float: left;
}

.btn {
  box-shadow: none !important;
}
</style>